import {HTMLAttributes} from 'react';
import {cn} from '../../libs';

export const Skeleton = ({className, ...props}: HTMLAttributes<HTMLDivElement>) => {
  return <div className={cn('animate-pulse rounded-md bg-bg-muted', className)} {...props} />;
};
